import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar/Navbar";
import Footer from "../../../Components/Footer/Footer";
import Style from "./index.module.css";
import instance from "../../../instance/AxiosInstance";
import Newsletter from "../../../Components/Newsletter/Newsletter";
import HomeProduct from "../../../Components/ProductWrapper/HomeProduct";
import {
  HiOutlineArrowNarrowLeft,
  HiOutlineArrowNarrowRight,
} from "react-icons/hi";

import HomeCarousel from "../../../Components/Carousels/HomeCarousel/HomeCarousel";
import LeftCategory from "../../../Components/HomeCategory/LeftCategory";
import RightCategory from "../../../Components/HomeCategory/RightCategory";
import ReffaralModal from "../../../Components/Models/RefferalModal/ReffaralModal";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../Contexts/UserContext";
import PolicyModal from "../../../Components/PolicyModal/PolicyModal";
import { LocationContext } from "../../../Contexts/LocationContext";
import { Helmet } from "react-helmet-async";
const Home = () => {
  const [location, setLocation] = useState([]);
  const { location: userLocation } = useContext(LocationContext); // Get location from context
  const [Products, SetProducts] = useState([]);
  // Removed SortedProducts - backend handles all sorting
  const [CurrentPage, SetCurrentPage] = useState(0);
  const [SliderImage, SetSliderImage] = useState([]);
  const [IsLastPage, SetIsLastPage] = useState(false);
  const [catToggle, setCatToggle] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [latestPolicy, setLatestPolicy] = useState(null);
  const [popData, setPopData] = useState()
  const [showModal, setShowModal] = useState(null);
  const { User } = useContext(UserContext)

  useEffect(() => {
    if (!User || !showModal || !User.showPopModal) return;
    console.log(User.showPopModal, "User showPopModal");

    setShowModal(true)
    const fetchLatestPolicy = async () => {
      try {
        const response = await instance.get("/api/user/privacy/get_latest_term");
        console.log("Fetched latest policy:", response.data);
        setLatestPolicy(response.data);

      } catch (error) {
        console.error("Failed to fetch latest policy:", error);
      }
    };

    fetchLatestPolicy();
  }, [User]); // ✅ re-run only when User is set

  const fetchpopData = () => {
    instance.get('/api/super_admin/pop/get_pop')
      .then((response) => {
        setPopData(response.data);
      })
      .catch((error) => {
        console.log(error, "modaldata");
      });
  }

  useEffect(() => {
    fetchpopData()
  }, []);




  const openPopModal = () => {
    setIsModalOpen(true);

    // Properly setting overflow to hidden
    document.body.style.overflow = 'hidden';

    // Clear localStorage when the tab is closed
    const handleTabClose = () => {
      localStorage.removeItem('hasSignedUp');
      localStorage.removeItem('isighnin');
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('beforeunload', handleTabClose);
    };
  };



  useEffect(() => {
    if (popData && !localStorage.getItem("hasOpenedModal")) {
      openPopModal();
      localStorage.setItem("hasOpenedModal", "true"); // Mark as opened

    }
  }, [popData]);





  const handleRefer = () => {
    // Remove hasSignedUp when user clicks Refer
    localStorage.removeItem('isighnin');
    // Add your Refer logic here
  };



  const { t } = useTranslation()

  // dispaly function for all categories in Top bar
  const changeToggle = () => {
    setCatToggle((prev) => !prev);
  };

  //animation to left cat bar

  useEffect(() => {
    if (catToggle) {
      requestAnimationFrame(() => setIsMounted(true));
    } else {
      setIsMounted(false);
    }
  }, [catToggle]);

  const loadProducts = () => {
    try {
      // Include location parameters in API call
      const lat = userLocation?.latitude || null;
      const lng = userLocation?.longitude || null;

      console.log("🏠 HOME loadProducts called - Location:", {
        lat,
        lng,
        city: userLocation?.city,
        isDefault: userLocation?.isDefault,
        source: userLocation?.source
      });

      const queryParams = new URLSearchParams({
        page: CurrentPage,
        ...(lat && { lat }),
        ...(lng && { lng })
      });

      console.log("🌐 API Request:", `/api/user/product/get_products?${queryParams.toString()}`);

      instance
        .get(`/api/user/product/get_products?${queryParams.toString()}`)
        .then((response) => {
          console.log("✅ Products loaded:", response.data.length, "items");
          SetProducts(response.data);
        })
        .catch((error) => {
          console.log("❌ Error loading products:", error);
        });
    } catch (error) {
      console.log("❌ Exception in loadProducts:", error);
    }
  };

  //LoadCategory functions
  useEffect(() => {
    loadProducts();
  }, [CurrentPage, userLocation?.latitude, userLocation?.longitude]); // Track specific coordinates

  // function ScrollToTopOnMount() {
  //   window.scrollTo(0, 0);
  //   return null;
  // }

  // useEffect(() => {
  //   ScrollToTopOnMount();
  // }, []);

  //LoadSlider Image functions
  useEffect(() => {
    try {
      instance
        .get("/api/user/slide/slides_view")
        .then((response) => {
          SetSliderImage([...response.data]);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  // -- functions to check that islast page
  useEffect(() => {
    try {
      instance
        .get(`/api/user/product/check_lastpage?page=${CurrentPage}`)
        .then((response) => {
          SetIsLastPage(response?.data?.lastPage);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, [CurrentPage]);

  // ============ BOOST SORTING LOGIC ============
  // Backend already sorts by: boostLevel DESC → boostedAt DESC → distance ASC → createdAt DESC
  // No need to re-sort on frontend - use products as-is from backend
  // ============ END BOOST SORTING ============
  console.log(showModal, "showModal-------------");


  const handlePreviousPage = () => {
    if (CurrentPage > 0) {
      SetCurrentPage((prev) => prev - 1); // go to previous page
    }
  };

  const handleNextPage = () => {
    if (!IsLastPage) {
      SetCurrentPage((prev) => prev + 1); // ✅ increase by 1 (page index)
    }
  };

  return (
    <div className={Style.home_container}>

      {/* <div className={Style.Top_container}>
        <TopCategory togglefunc={setCatToggle} toggleState={catToggle} />
      </div> */}
      {/* <ScrollToTopOnMount /> */}
      <Navbar setLocation={setLocation} location={location} togglefunc={setCatToggle} toggleState={catToggle} />
      {
        isModalOpen ? (
          <div className={Style.Reffermodal_container}>
            <ReffaralModal handleRefer={handleRefer} setIsModalOpen={setIsModalOpen} modalData={popData} />
          </div>
        ) : ""
      }

      <HomeCarousel items={SliderImage} />
      <div className={Style.Main_container}>
        <div className={Style.Left} style={{ display: catToggle ? 'block' : 'none' }}>
          {
            catToggle &&
            <div
              className={`${Style.left_cat} ${isMounted ? Style.left_catenter : ""
                }`}
            >
              <LeftCategory />
            </div>
          }

        </div>

        {/* {
      catToggle &&  
      <div className={Style.Left}>
        <LeftCategory />
      </div> 
     } */}

        <div className={Style.Right}>
          <RightCategory />
          <div className={Style.cardWrapper}>
            <HomeProduct sortedproducts={Products} />
            {Products.length !== 0 ? (
              <div className={Style.loadbtn}>
                <button
                  onClick={handlePreviousPage}
                  className={
                    CurrentPage === 0
                      ? `${Style.inactiveBtn}`
                      : `${Style.activeBtn}`
                  }
                  disabled={CurrentPage === 0}
                >
                  <HiOutlineArrowNarrowLeft className={Style.icon} /> {t("Prev")}
                </button>
                <button
                  onClick={handleNextPage}
                  className={
                    IsLastPage ? `${Style.inactiveBtn}` : `${Style.activeBtn}`
                  }
                  disabled={IsLastPage}
                >
                  {t("Next")}
                  <HiOutlineArrowNarrowRight className={Style.icon} />
                </button>
              </div>
            ) : null}
          </div>
          {showModal && latestPolicy && (
            <PolicyModal policy={latestPolicy} showModal={showModal} userId={User._id} setShowModal={setShowModal} />
          )}

          {/* {
          GdprModal && (<GDPRInfoModal handleClose= {handleGdprClose}/>)
        } */}
          {/* {showInterestModal && <InterestForm userId={User._id} handleClose={handleInterestClose} />} */}
        </div>
      </div>
      <Newsletter />

      {/* ===== Mobile App Download Section ===== */}
      <div className={Style.appDownloadSection}>
        <div className={Style.appDownloadContent}>
          <h2 className={Style.appDownloadTitle}>Get the DealNBuy App</h2>
          <p className={Style.appDownloadSubtitle}>
            Shop smarter, discover better deals — on the go!
          </p>
          <div className={Style.appBtnGroup}>
            {/* Android – Google Play */}
            <a
              href="https://play.google.com/store/apps/details?id=com.dealnbuy.app"
              target="_blank"
              rel="noopener noreferrer"
              className={Style.officialBadgeLink}
            >
              <div className={Style.badgeContainer}>
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                  className={`${Style.officialBadgeImg} ${Style.googlePlayBadge}`}
                />
              </div>
            </a>

            {/* iOS – Coming Soon */}
            <div className={Style.officialBadgeWrapper}>
              <span className={Style.comingSoonBadge}>Soon</span>
              <div className={Style.badgeContainer}>
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className={`${Style.officialBadgeImg} ${Style.officialBadgeDisabled}`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===== End Mobile App Download Section ===== */}

      <Footer />
    </div>
  );
};

export default Home;
